<template>
  <div
    v-if="provider"
    class="fulfiller-info"
  >
    <p class="fulfiller-info__provider">
      <Modal
        v-if="hasBrodosInfo"
        close-on-backdrop
        heading-text="Brodos AG"
      >
        <template #trigger="{ open }">
          <LinkButton
            tag="button"
            data-tealium-rel="content.text.hier"
            text
            no-styling
            @click="open"
          >
            Verkauf und Versand durch {{ originDisplayName }}.
          </LinkButton>
        </template>
        <BrodosInfoModal />
      </Modal>
      <span v-else> Verkauf und Versand durch {{ originDisplayName }}.</span>
      <template v-if="isFreightForwardingService">
        Kostenfreie Speditionslieferung durch Rhenus Home Delivery nach individueller
        Terminabsprache.
      </template>
    </p>

    <p v-if="hasBrodosInfo">
      <NuxtLink
        to="/weitere-informationen/ueber-brodos"
        data-tealium-rel="content.text.hier"
        class="link"
      >
        Informationen zum Bestellablauf.
      </NuxtLink>
    </p>
    <p v-if="hasTelekomInfo">
      <Modal
        close-on-backdrop
        heading-text="Informationen zum Bestellablauf"
      >
        <template #trigger="{ open }">
          <LinkButton
            tag="button"
            data-tealium-rel="content.text.hier"
            text
            no-styling
            @click="open"
          >
            Informationen zum Bestellablauf.
          </LinkButton>
        </template>
        <TelekomInfoModal />
      </Modal>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue';
import BrodosInfoModal from '@/components/brodos-info-modal.vue';
import TelekomInfoModal from '@/components/telekom-info-modal.vue';
import type { ProductProviderKey } from '~/lib/goliath/goliath.types';
import { Modal, LinkButton } from '@i22-td-smarthome/component-library';

const POSSIBLE_PROVIDER: Record<ProductProviderKey, string> = {
  BRODOS: 'Brodos AG',
  TELEKOM: 'Telekom Deutschland GmbH',
  TVPP: 'Telekom Deutschland GmbH',
};

const props = defineProps({
  provider: { type: String as PropType<ProductProviderKey>, required: true },
  isFreightForwardingService: { type: Boolean },
});

const hasBrodosInfo = computed(() => props.provider === 'BRODOS');
const hasTelekomInfo = computed(() => props.provider === 'TELEKOM');
const originDisplayName = computed(() => POSSIBLE_PROVIDER[props.provider] || props.provider);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.fulfiller-info {
  p {
    @include font-size(15px, 20px);
    margin-bottom: 3px; // add space to get the 24px height (WCAG 2.5.8)
  }
  &__provider {
    padding: 0;
    margin: 0;
  }
}
</style>
